import { OptimizedImageSize } from "../OptimizedImage";
import { getUrl } from "aws-amplify/storage";

const EXTENSION_MAP: Record<string, string> = {
  jpeg: "jpg",
  heic: "jpg",
  heif: "jpg",
  mpo: "jpg",
  tiff: "png",
  bmp: "png",
};

const useOptimizedImageKey = async (
  imageKey: string,
  imageSize: OptimizedImageSize,
) => {
  const rawExtension = imageKey.split(".").pop() ?? "jpg";
  const correctedExtension = rawExtension.length < 10 ? rawExtension : "jpg";

  const extension = EXTENSION_MAP[correctedExtension] ?? correctedExtension;

  const name =
    extension === rawExtension
      ? imageKey.replace(`.${extension}`, "")
      : imageKey;

  if (imageSize === "original") {
    const response = await getUrl({ path: imageKey });
    return response.url.toString();
  } else {
    const scaledKey = name.concat(`.scaled.${imageSize}.${extension}`);

    const response = await getUrl({ path: scaledKey });
    return response.url.toString();
  }
};

export default useOptimizedImageKey;
